import OtherTypesConfig from '@/config/other-types';

export default function seriaAndNumberCheck (value) {
	const regExp = /[ЁёА-я а-яієІїґ a-zA-Z]{3}\d{6}/

	return regExp.test(value) && value.length === OtherTypesConfig.SERIA_AND_NUMBER_LENGTH
}